<template>
  <div class="lobby-list">
    <Header 
      title="Muro da VERGONHA" 
      subtitle="lista dos usuários banidos"
    ></Header>
    <div class="container">
      <div class="stats-table table-responsive">
        <table class="table is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th><abbr title="Nickname">Nickname</abbr></th>
              <th><abbr title="Motivo">Motivo</abbr></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td>
                <router-link :to="{ name: 'UserSingle', params: { id: user.to_param }}">
                  {{user.nickname}}
                </router-link>
              </td>
              <td v-if="user.ban_reason">{{ user.ban_reason }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

  </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  name: 'WallOfShame',
  metaInfo: {
    title: 'Muro da VERGONHA'
  },
  data () {
    return {
      users: []      
    }
  },
  methods: {
    initialize() {
      this.$http
        .get('wall_of_shame.json')
        .then(response => (this.users = response.data.users))
      
    }
  },
  mounted () {
    this.initialize()
  },
  components: {
    Header
  }
}
</script>
